<template>
  <div>
    <!-- 商品详细信息弹窗 -->
    <van-popup v-model="showDetial" round :style="{ width: '85%' }">
      <div style="display: flex" class="dis-bg">
        <van-field v-model="shopName" label="商   品" disabled />
        <van-field class="short-txt" style="width: 4rem" v-model="shopIndex1" label="序号" disabled />
      </div>
      <div class="dis-bg">
        <van-field v-model="standardName" label="规格等级" disabled />
        <van-field v-model="targetName" label="监测指标" disabled />
      </div>
      <div style="display: flex; border-bottom: 1px solid rgb(235 237 240 / 77%); margin-left: 0.2rem" v-if="handCheckConfig('isGoods', 'show')">
        <div class="goodIs">{{ handCheckConfig('isGoods', 'name') ? handCheckConfig('isGoods', 'name') : '无此品种' }}</div>
        <van-checkbox v-model="isGoods" shape="square" class="import" @change="changeIsGoods" :disabled="saveState"></van-checkbox>
      </div>
      <van-field
        v-if="detailData.dataType !== '1003'"
        v-model="bqPrice"
        :label="dataType ? '当期数据' : '当期价格'"
        :placeholder="dataType ? '可输入文字' : ''"
        type="number"
        :disabled="isGoods || saveState"
        class="dqjg import"
        @blur="handInputBlur"
      >
        <template #extra>
          <div style="color: #5e5b5b">{{ unitName }}</div>
        </template>
      </van-field>
      <van-field
        v-else
        v-model="importInfo"
        :label="dataType ? '当期数据' : '当期价格'"
        :disabled="isGoods || saveState"
        class="dqjg import"
        :placeholder="dataType ? '可输入文字' : ''"
      >
        <template #extra>
          <div style="color: #5e5b5b">{{ unitName }}</div>
        </template>
      </van-field>
      <van-field
        v-model="content"
        rows="3"
        autosize
        label=""
        type="textarea"
        maxlength="50"
        minlength="2"
        :class="['long-txt', 'import', placeholder && !content && placeholder !== '请填写波动原因说明' ? 'redPlacer' : '']"
        show-word-limit
        :disabled="saveState"
        :placeholder="placeholder"
      >
        <template #label>
          <div class="bdyy">
            <div>波动原因说明</div>
            <div class="xx-box" @click="handOpenXX" v-if="!saveState">选项</div>
          </div>
        </template>
      </van-field>
      <van-field
        v-model="backInfo"
        label="退回原因"
        :disabled="saveState"
        class="dqjg import"
        placeholder="请输入退回原因"
      >
      </van-field>
      <div style="display: flex" class="dis-bg">
        <van-field v-model="detailData.hbNum" label="环   比" disabled />
        <van-field v-model="ringPrice" label="上期价格" disabled />
      </div>
      <div class="bottom">
        <div style="display: flex; box-shadow: rgba(0, 0, 0, 0.1) 0px -1px 10px; height: 100%; align-items: center">
          <div offset="1" style="text-align: center; flex: 1; position: relative">
            <v-button class="btn1" @click="closeBasic()">取消</v-button>
          </div>
          <div offset="1" style="text-align: center; flex: 1; position: relative" v-if="!saveState">
            <v-button class="btn1 btn2" :class="{ bianhui: saveState }" @click="saveBasic()">保存</v-button>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 说明原因弹窗 -->
    <van-popup v-model="showReason" position="bottom" round closeable :style="{ height: '40%' }">
      <van-sticky>
        <div class="reasonTitle">请选择波动说明原因</div>
      </van-sticky>
      <div class="reason-box">
        <div class="reason-item" v-for="(item, index) in reasonList" :key="index" @click="handreasonSure(item)">
          {{ item.name }}
          <van-icon name="success" color="#0052D9" size="0.45rem" v-if="item.checked" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { listCodeItemBatch2 } from '@/api/baseMsg';
import rulesInfoDeal from '@/utils/dataRules.js';
import { Toast } from 'vant';
export default {
  props: {
    saveState: {
      type: Boolean,
      default: false
    },
    backShow: {
      type: Boolean,
      default: false
    },
    isGoodsName: {
      type: String,
      default: ''
    },
    levelNum: {
      type: String,
      default: ''
    },
    taskConfig: {
      type: Array,
      default: () => {
        return [];
      }
    },
    function: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDetial: false,
      shopName: '',
      standardName: '',
      targetName: '',
      isGoods: false,
      bqPrice: '',
      importInfo: '',
      unitName: '',
      placeholder: '',
      shopIndex1: '',
      ringPrice: '',
      content: '',
      bqPriceSave: '',
      importInfoSave: '',
      contentSave: '',
      showReason: false,
      reasonList: [],
      detailData: {},
      dataType: '',
      backInfo: ''
    };
  },
  watch() {},
  created() {
    this.getReasonList();
  },
  methods: {
    // 动态列
    handCheckConfig(str, val) {
      let result = '';
      this.taskConfig.forEach((i) => {
        if (i.displayColumnValue == str && val == 'show') {
          result = i.isDisplay;
          if (this.levelNum == 3 || this.function == 'xm') {
            result = 1;
          }
        }
        if (i.displayColumnValue == str && val == 'name') {
          result = i.autoColumn ? i.autoColumn : i.displayColumnName;
        }
        if (i.displayColumnValue == str && val == 'width') {
          result = i.widthColumn;
        }
      });
      if(this.taskConfig.length == 0  && val == 'show') {
        result = 1
      }
      return result;
    },
    // 处理数据
    initData(item) {
      this.detailData = item;
      this.dataType = item.dataType;
      this.shopIndex1 = item.shopIndex1;
      this.ringPrice = item.ringPrice;
      this.shopName = item.VarietyName;
      this.standardName = item.StandardName;
      this.targetName = item.TargetName;
      this.unitName = item.UnitName;
      this.bqPrice = item.ThisPrice; //本期价格
      this.bqPriceSave = item.ThisPrice;
      this.importInfo = item.importInfo;
      this.importInfoSave = item.importInfo;
      this.isGoods = item.isGoods == 1 ? true : false;
      this.contentSave = item.Memo; //说明
      this.content = item.Memo; //说明
      this.backInfo = item.backInfo
      this.placeholder = item.placeholder ? item.placeholder : '请填写波动原因说明';
      this.$forceUpdate();
      this.showDetial = true;
    },
    // 关闭弹窗
    closeBasic() {
      this.showDetial = false;
      this.isGoods = false;
      this.detailData = '';
      this.dataType = '';
      this.shopIndex1 = '';
      this.ringPrice = '';
      this.shopName = '';
      this.standardName = '';
      this.targetName = '';
      this.unitName = '';
      this.bqPrice = '';
      this.bqPriceSave = '';
      this.importInfo = '';
      this.importInfoSave = '';
      this.contentSave = '';
      this.content = '';
      this.placeholder = '';
      this.backInfo = ''
    },
    // 保存
    saveBasic() {
      if (this.dataType != '1003' && !this.content && this.placeholder && this.placeholder != '请填写波动原因说明') {
        Toast(this.placeholder);
      } else {
      this.$emit('saveBasic', {
          bqPrice: this.bqPrice,
          content: this.content,
          isGoods: this.isGoods,
          importInfo: this.importInfo,
          backInfo: this.backInfo
        });
        this.$nextTick(() => {
          this.closeBasic();
        });
      }
    },
    // 无此品种点击
    changeIsGoods() {
      if (this.isGoods == true) {
        this.bqPriceSave = this.bqPrice;
        this.importInfoSave = this.importInfo;
        this.bqPrice = 0.0;
        this.importInfo = '';
        this.contentSave = this.content;
        this.content = this.isGoodsName ? this.isGoodsName : '无此品种';
      } else {
        this.bqPrice = this.bqPriceSave == 0 ? '' : this.bqPriceSave;
        this.importInfo = this.importInfoSave == '' ? '' : this.importInfoSave;
        if (this.contentSave) {
          this.content = '';
        } else {
          this.content = this.contentSave == (this.isGoodsName ? this.isGoodsName : '无此品种') ? '' : this.contentSave;
        }
      }
    },
    //
    handInputBlur() {
      let detailData = JSON.parse(JSON.stringify(this.detailData));
      detailData.ThisPrice = this.bqPrice;
      let reason = rulesInfoDeal(detailData);
      if (reason.isWarn && reason.warnMsg) {
        this.placeholder = reason.warnMsg;
      } else {
        this.placeholder = '请填写波动原因说明';
      }
    },
    // 选项
    getReasonList() {
      listCodeItemBatch2({ dmgrp: 'code_importRemark' }).then((res) => {
        if (res.code == 200) {
          res.data.forEach((i) => {
            i.checked = false;
          });
          this.reasonList = res.data;
        } else {
          this.reasonList = [];
        }
      });
    },
    handOpenXX() {
      this.reasonList.forEach((i) => {
        i.checked = false;
        if (this.content.indexOf(i.name) > -1) {
          i.checked = true;
        }
      });
      this.showReason = true;
    },
    handreasonSure(row) {
      this.reasonList.forEach((i) => {
        if (i.id == row.id) {
          i.checked = !i.checked;
        }
      });
      let text = '';
      let val = row.name;
      if (this.content) {
        text = String(this.content);
      }
      // 一个是累加到 input框中、
      if (text.indexOf(val) > -1) {
        if (text.length === val.length) {
          this.content = '';
        } else {
          /**
           * 这里判断输入框中 存在快捷选项进入判断
           * 判断点击的快捷选项往前一个字符和往后一个字符包不包含,号
           * 过滤：
           * 若快捷选项从0开始，有一个,号
           * 若快捷选项在中间，必须有两个,号
           *
           * 替换：
           * 其他情况就只替换快捷选项为空即可
           */
          const start = text.indexOf(val);
          const valStr = text.substring(Number(start) - 1, Number(start) + Number(val.length) + 1);
          const valStrTwo = valStr.split('、').length - 1;
          if (
            (Number(start) === 0 && valStr.indexOf('、') > -1) ||
            Number(valStrTwo) === 2 ||
            (Number(start) + Number(val.length) === text.length && valStr.indexOf('、') > -1)
          ) {
            this.content = text
              .split('、')
              .filter((item) => item !== val)
              .join('、');
          } else {
            this.content = text.replace(val, '');
          }
        }
      } else {
        if (text.length > 0) {
          this.content = text + `、${val}`;
        } else {
          this.content = val;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.dis-bg {
  background-color: #f9f9f9;
  /deep/.van-field--disabled .van-field__label {
    color: #666666;
  }
  /deep/.van-field__control:disabled {
    color: #666666;
    -webkit-text-fill-color: #666666 !important;
    font-weight: 400 !important;
  }
  /deep/.van-cell {
    background-color: transparent;
  }
}
.short-txt {
  /deep/ .van-field__label {
    min-width: 1rem !important;
    width: 1.4rem !important;
  }
}
/deep/ .van-field__label {
  min-width: 1.855rem !important;
  line-height: 0.5rem !important;
  margin-top: 0.2rem;
  margin-right: 0;
  color: #000000;
}
/deep/.van-field--disabled .van-field__label {
  color: #000000;
}
/deep/.import .van-field__control:disabled {
  color: #000000;
  -webkit-text-fill-color: #000000;
  font-weight: 400 !important;
}
/deep/.van-checkbox__icon .van-icon {
  border: 1px solid #3e3e3e;
}
/deep/.van-checkbox--disabled .van-checkbox__icon .van-icon {
  border: 1px solid #c8c9cc;
}
.goodIs {
  width: 2.2rem;
  padding-left: 0.2rem;
  font-size: 0.37037rem;
  line-height: 1.2rem;
  height: 1.2rem;
  color: #000000;
}
.dqjg {
  /deep/.van-field__body {
    border-bottom: 1px solid #9cdbff;
    border-radius: 2px;
  }
}

.long-txt {
  display: flex;
  flex-direction: column;
  /deep/.van-field__control::-webkit-input-placeholder {
    color: #c8c9cc !important;
    -webkit-text-fill-color: #c8c9cc;
  }
  /deep/.van-field__label {
    white-space: nowrap;
    line-height: 0.5rem !important;
    margin-top: 0.2rem;
  }
  /deep/.van-field__value {
    margin-top: 8px;
  }
  /deep/.van-field__control {
    line-height: 28px;
    background: #f7f8fa;
  }
  .bdyy {
    display: flex;
    align-items: center;
    .xx-box {
      border-radius: 2px;
      background: #e8f3ff;
      border: 1px solid #e8f3ff;
      color: #498dfe;
      font-size: px2rem(36);
      text-align: center;
      padding: 0.05rem 0.35rem;
      margin-left: 0.2rem;
    }
  }
}
.redPlacer {
  /deep/.van-field__control::-webkit-input-placeholder {
    color: red !important;
    -webkit-text-fill-color: red;
  }
}
.reasonTitle {
  padding: 0.4rem;
  color: #000000e5;
  font-family: PingFang SC;
  font-size: px2rem(38);
  text-align: left;
  font-weight: bold;
}
.reason-box {
  .reason-item {
    font-size: px2rem(36);
    text-align: left;
    padding: 0.4rem;
    color: #333333;
    border-bottom: 1px solid #f1f1f1;
    display: flex;
    justify-content: space-between;
    .dui-icon {
      color: #0052d9;
    }
  }
}
.dialog-btn {
  display: inline-block;
  width: 2rem;
  height: 1rem;
  line-height: 1rem;
  border-radius: 1rem;
  background-color: #fff;
  color: #666666;
  font-size: px2rem(45);
  text-align: center;
  vertical-align: middle;
  margin-top: 0.4rem;
}
.btn-blue {
  color: #006fcd;
}
//审核过的事项 底部按钮变灰
.bianhui {
  pointer-events: none;
  filter: grayscale(1);
  .btn1 {
    font-weight: 400;
    color: #ababab;
  }
}
.bottom {
  width: 100%;
  height: 1.2rem;
  background-color: #fff;
  .btn1 {
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    font-size: px2rem(45);
    color: #2c7fe2;
    font-weight: bold;
    font-family: 'Microsoft YaHei', 微软雅黑, Arial, sans-serif;
    width: 2rem;
  }
  v-button.btn1::after {
    content: '';
    width: 0.02rem;
    height: 0.6rem;
    background: #ababab;
    position: absolute;
    right: 0;
  }
  v-button.btn2::after {
    content: '';
    width: 0rem;
    height: 0rem;
  }
}
</style>
